const language = document.documentElement.lang

const parseDOM = (data, type = 'text/html') => new DOMParser().parseFromString(data, type)

const serializeDOM = data => new XMLSerializer().serializeToString(data)

export { language, parseDOM, serializeDOM }
